  // Product Bundle 今すぐ購入 功能
  document.addEventListener('DOMContentLoaded', function () {
    const productBundleForms = document.querySelectorAll('.product-bundle-buy-now');

    productBundleForms.forEach(function (form) {
      const submitButton = form.querySelector('.buy-now-button');
      const productForm = form.querySelector('.product-bundle-form');
      const errorWrapper = form.querySelector('.product-form__error-message-wrapper');
      const errorMessage = form.querySelector('.product-form__error-message');
      const loadingIcon = form.querySelector('.icon-load');
      const buttonLabel = form.querySelector('.btn-label');

      if (submitButton && productForm) {
        submitButton.addEventListener('click', function (e) {
          e.preventDefault();

                  // 检查按钮是否被禁用（主产品缺货）
        if (submitButton.hasAttribute('disabled') || submitButton.disabled) {
          return;
        }

          // 显示加载状态
          submitButton.disabled = true;
          loadingIcon.style.opacity = '1';
          buttonLabel.textContent = 'Processing...';

          // 隐藏错误信息
          if (errorWrapper) {
            errorWrapper.hidden = true;
          }

          // 收集表单数据
          const formData = new FormData(productForm);
          
          // 检查是否包含赠品
          const hasGiftProduct = formData.get('items[1][id]') !== null;

          // 发送到 /cart/add.js
          fetch('/cart/add.js', {
            method: 'POST',
            body: formData,
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
            },
          })
            .then((response) => {
              if (!response.ok) {
                return response.json().then((err) => Promise.reject(err));
              }
              return response.json();
            })
            .then((data) => {
              // 成功添加到购物车
              // 如果没有赠品，显示提示信息
              if (!hasGiftProduct) {
                // 显示赠品缺货提示
                if (errorWrapper && errorMessage) {
                  errorMessage.textContent = 'Gift product is currently out of stock. Only main product has been added to cart.';
                  errorWrapper.hidden = false;
                  errorWrapper.style.marginBottom = '10px';
                }
                
                // 延迟跳转，让用户看到提示
                setTimeout(() => {
                  redirectToCheckout();
                }, 2000);
              } else {
                // 立即跳转
                redirectToCheckout();
              }

              function redirectToCheckout() {
                const discountCode = form.getAttribute('data-discount-code');
                let checkoutUrl = '/checkout';

                // 如果有折扣码，添加到 URL 参数中
                if (discountCode && discountCode.trim() !== '') {
                  checkoutUrl += '?discount=' + encodeURIComponent(discountCode.trim());
                }

                window.location.href = checkoutUrl;
              }
            })
            .catch((error) => {
              console.error('Error:', error);

              // 显示错误信息
              if (errorWrapper && errorMessage) {
                let errorText = 'Unable to add item to cart.';

                if (error.message) {
                  errorText = error.message;
                } else if (error.description) {
                  errorText = error.description;
                }

                errorMessage.textContent = errorText;
                errorWrapper.hidden = false;
              }

                          // 恢复按钮状态
            submitButton.disabled = false;
            loadingIcon.style.opacity = '0';
            
            // 根据按钮原始状态恢复文字
            if (submitButton.classList.contains('btn-disabled')) {
              buttonLabel.textContent = 'Out of Stock';
              submitButton.disabled = true;
            } else {
              buttonLabel.textContent = '今すぐ購入';
            }
            });
        });
      }
    });
  });